import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import { SubmenuDivHandler } from './SubmenuDivHandler.js';
import { IntifaceController } from '../IntifaceController.js';
import Logger from '../utils/logger.js';
import { applyComponentStyles } from '../utils/shared-styles.js';

const MODULE = 'RemoteDeviceConnSubmenu';

const CSS = `
        /* Style for the Video Share preview video */
        .mm-preview-video {
            height: 240px;
            width: 360px;
            border: 2px solid #000;
            border-radius: 4px;
        }*/
`;

const MM_REMOTECONN_HTML = `
        <!-- Modal content for Remote Device Connection menu -->
        <div id="menu-modal-remotedeviceconn" class="menu-modal-content">
            <h2>Remote Device Connection</h2>
            <p>Connect to another User's Devices<br>
            User's Key:<input type="text" id="mm-remotedevice-conn-key-input" class="mm-text-input" onkeydown="event.stopPropagation()">
            <button id="mm-remotedevice-conn-connect-button" class="mm-submit-button">Connect</button>
            </p>
        </div>
`;

/**
 * RemoteDeviceConnSubmenuDH
 */
export class RemoteDeviceConnSubmenuDH extends SubmenuDivHandler {
    static TypeName = 'RemoteDeviceConnSubmenuDH';

    constructor() {
        super();

        // Apply remote device connection specific styles (shared styles applied by MenuController)
        applyComponentStyles(CSS, 'remote-device-conn-submenu');
    }

    updateConditionals(): void {

    }

    displayMenuContent(containerDiv: HTMLDivElement): void {
        containerDiv.innerHTML = MM_REMOTECONN_HTML;
        
        const inputKey = document.getElementById('mm-remotedevice-conn-key-input') as HTMLInputElement;     
        const btnConnectRemote = document.getElementById('mm-remotedevice-conn-connect-button') as HTMLButtonElement;
        if (!inputKey || !btnConnectRemote ) {
            Logger.error(MODULE, 'Menu Controller could not find one or more named resources in current menu content. These html objects should have been injected by this class at runtime.');
            return;
        }

        btnConnectRemote.addEventListener('click', () => {
            IntifaceController.instance.ConnectRemoteDevices(inputKey.value);
        });
    }

    hideContent(): void {
        const btnConnectRemote = document.getElementById('mm-remotedevice-conn-connect-button') as HTMLInputElement;

        var newBtn = btnConnectRemote?.cloneNode(true);
        if (newBtn) {
            btnConnectRemote?.parentNode?.replaceChild(newBtn, btnConnectRemote);
        }
    }
}
